import { render, staticRenderFns } from "./TrangDanhSachHoSoCanBo.vue?vue&type=template&id=f915fb06&"
import script from "./TrangDanhSachHoSoCanBo.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachHoSoCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports